import React from 'react';

import delv from 'dlv';

import { MenuObject } from '@rbi-ctg/menu';
import LoadingAnimation from 'components/loading-animation';
import LoadingContainer from 'components/loading-animation/loading-container';

import Guide from './guide';
import Hero from './hero';
import LayoutContainer from './layout-container';
import Wizard from './wizard';
import { WizardProvider } from './wizard-provider';

const MenuOrderWizard: React.FC<{ data: MenuObject; loading: boolean }> = props => (
  <WizardProvider>
    <LayoutContainer>
      {props.loading ? (
        <LoadingContainer>
          <LoadingAnimation fillColor={Styles.color.primary} />
        </LoadingContainer>
      ) : (
        <>
          <Hero image={delv(props, 'data.image')} alt="" />
          <Guide>
            <Wizard {...props} />
          </Guide>
        </>
      )}
    </LayoutContainer>
  </WizardProvider>
);

export default MenuOrderWizard;
